export default __webpack_public_path__ + "static/media/loading.c21499e0.gif";